export default __webpack_public_path__ + "static/media/rj_box_logo.c5c5957e.png";